export const oralInterviewMutationFeedback = (result, fallbackMessage) => {
  if (result?.success) return null;

  return result?.notice || result?.errors?.[0]?.messages?.[0] || fallbackMessage;
};
